// extracted by mini-css-extract-plugin
export var bodySections = "_ea-8";
export var gray = "_ea-7";
export var green = "_ea-4";
export var iconContainer = "_ea-9";
export var iconWidgetContainer = "_ea-1";
export var phoneIcon = "_ea-2";
export var red = "_ea-5";
export var statusDot = "_ea-3";
export var widgetContainer = "_ea-0";
export var yellow = "_ea-6";